import { Box, Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
import SubContractorList from "../components/operation/subContractor/SubContractorList";
import { useDispatch } from "react-redux";
import {
  getAllSubContractorAction,
  setAddSubContractorResponse,
  setDeleteSubContractorResponse,
} from "../../store/reducers/subContractor";
import SubContractorDetails from "../components/operation/subContractor/SubContractorDetails";
import { useSelector } from "react-redux";

const ClinetSubContractors = () => {
  const dispatch = useDispatch();
  const { isDeleteResponseSuccess, isAddSubContractorSuccess } = useSelector(
    (state: any) => state.subContractor
  );
  const [filterOption, setFilterOption] = useState<any>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });
  const [selectedId, setSelectedId] = useState<string | null>(null);

  useEffect(() => {
    dispatch(getAllSubContractorAction(filterOption));
    dispatch(setDeleteSubContractorResponse(false));
    dispatch(setAddSubContractorResponse(false));
  }, [filterOption, isDeleteResponseSuccess, isAddSubContractorSuccess]);

  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 12 }}
        sx={{ background: "#f4f4f4", paddingTop: "16px", height: "100vh" }}
      >
        <Grid
          item
          xs={12}
          md={4}
          sx={{ paddingLeft: "0px !important", paddingTop: "0px !important" }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              height: { xs: "auto", md: "100vh" },
              // border: "1px solid #d1cfcf",
              // borderRadius: "5px",
              // padding: "4px",
            }}
          >
            <SubContractorList
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              filterOption={filterOption}
              setFilterOption={setFilterOption}
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={8}
          sx={{ paddingLeft: "16px !important", paddingTop: "0px !important" }}
        >
          <Container
            maxWidth="lg"
            sx={{
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              background: "#fff",
            }}
          >
            <Box
              sx={{
                height: { xs: "auto", md: "100vh" },
                // border: "1px solid #d1cfcf",
                // borderRadius: "5px",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
                // padding: "0px 16px",
                overflow: "scroll",
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  bgcolor: "#fff",
                  zIndex: 1,
                  border: "1px solid #C4CDD5",
                }}
              >
                <PageInfoTitle
                  title="Sub Contractor Details"
                  // button={selectedId ? "Edit" : ""}
                  // onClick={() => handleEditVehicle(selectedId)}
                />
              </Box>
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto" },
                  //   border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  overflow: "hidden",
                  // padding: "10px",
                  padding: "10px 10px !important",
                }}
              >
                {selectedId ? (
                  <SubContractorDetails
                    selectedId={selectedId}
                    // onEditClick={() => console.log("Edit clicked")}
                  />
                ) : (
                  <Box
                    sx={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#4A4A4A",
                      fontWeight: 500,
                    }}
                  >
                    Please select a sub contractor to see details
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default ClinetSubContractors;
